// src/utils/saveFilters.js
import { useState, useEffect, useCallback, useRef } from 'react';

const FILTER_VALUES_KEY = 'diariaFilterValues';
const FILTER_STATE_KEY = 'diariaFilterState';

export const SAVED_FILTER_KEYS = [FILTER_VALUES_KEY, FILTER_STATE_KEY];

export function useSaveFilters() {
  // Estado padrão dos filtros
  const defaultStateRef = useRef({
    searchValue: '',
    selectedField: 'Protocolo',
    selectedRegional: 'Regional',
    selectedCad: 'Cadastrador',
    selectedSit: 'situacao',
    selectedYear: new Date().getFullYear(),
  });

  const [filterValues, setFilterValues] = useState([]);
  const [filterState, setFilterState] = useState(defaultStateRef.current);

  // Carrega filtros salvos no localStorage ao montar
  useEffect(() => {
    try {
      const storedValues = localStorage.getItem(FILTER_VALUES_KEY);
      if (storedValues) {
        const parsed = JSON.parse(storedValues);
        if (Array.isArray(parsed)) {
          setFilterValues(parsed);
        }
      }

      const storedState = localStorage.getItem(FILTER_STATE_KEY);
      if (storedState) {
        const parsed = JSON.parse(storedState);
        if (parsed && typeof parsed === 'object') {
          setFilterState((prev) => ({
            ...prev,
            ...parsed,
          }));
        }
      }
    } catch (e) {
      console.error('Erro ao carregar filtros do localStorage:', e);
    }
  }, []);

  // Salva lista de filtros (chips) sempre que mudar
  useEffect(() => {
    try {
      localStorage.setItem(FILTER_VALUES_KEY, JSON.stringify(filterValues));
    } catch (e) {
      console.error('Erro ao salvar filtros (values) no localStorage:', e);
    }
  }, [filterValues]);

  // Salva estado dos dropdowns/campos sempre que mudar
  useEffect(() => {
    try {
      localStorage.setItem(FILTER_STATE_KEY, JSON.stringify(filterState));
    } catch (e) {
      console.error('Erro ao salvar filtros (state) no localStorage:', e);
    }
  }, [filterState]);

  const addFilterValue = useCallback((value) => {
    const trimmed = String(value || '').trim();
    if (!trimmed) return;

    setFilterValues((prev) => {
      if (prev.includes(trimmed)) return prev;
      return [...prev, trimmed];
    });
  }, []);

  const removeFilterValue = useCallback((value) => {
    setFilterValues((prev) => prev.filter((v) => v !== value));
  }, []);

  // Limpa tudo (pode receber overrides, ex.: manter regional travada)
  const clearAllFilters = useCallback((overrides = {}) => {
    setFilterValues([]);
    setFilterState({
      ...defaultStateRef.current,
      ...overrides,
    });
  }, []);

  return {
    filterValues,
    addFilterValue,
    removeFilterValue,
    filterState,
    setFilterState,
    clearAllFilters,
  };
}
